import axios from 'axios';
import {
  acquireAccessTokenOrRedirect,
  redirectToLogin,
  storeAuthError,
  SESSION_EXPIRED_MESSAGE,
} from '@/auth/authSession';
import { getSelectedTenantId } from '@/lib/tenantStorage';

export const client = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: { indexes: null },
});

client.interceptors.request.use(
  async (config) => {
    const token = await acquireAccessTokenOrRedirect();
    if (!token) {
      throw new Error('No access token');
    }
    config.headers.Authorization = `Bearer ${token}`;

    const tenantId = getSelectedTenantId();
    if (tenantId) {
      config.headers['X-Tenant-Id'] = tenantId;
    }

    return config;
  },
  (error) => {
    throw error;
  }
);

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      storeAuthError(SESSION_EXPIRED_MESSAGE);
      await redirectToLogin();
    }
    throw error;
  }
);
